import { render, staticRenderFns } from "./UploadArrowIcon.vue?vue&type=template&id=daff12e6"
import script from "./UploadArrowIcon.vue?vue&type=script&lang=ts"
export * from "./UploadArrowIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports